export const months: string[] = [
  "Jan",
  "Fév",
  "Mars",
  "Avr",
  "Mai",
  "Juin",
  "Jui",
  "Août",
  "Sep",
  "Oct",
  "Nov",
  "Déc",
];

export const days: string[] = [
  "Lundi",
  "Mardi",
  "Marcredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
  "Dimanche",
];
